import { getInventoryListViewRoute } from "@slfinrtl/ui-bff-routes"
import type { InventoryListFilterValue, InventoryListSettings } from "@slfinrtl/ui-bff-routes"
import { useBffDynamic } from "src/hooks"

const limit = 50
export const useInventoryListView = () => {
	const fetchList = useBffDynamic(getInventoryListViewRoute, "inline")

	return ([settingsString, pageIndex]: [string, number]) => {
		const settings: InventoryListSettings = JSON.parse(settingsString)
		const { sortBy, sortDir, ...filterValue } = settings
		const sorting = { sortBy, sortDir }

		return fetchList({
			body: undefined,
			pathParams: {},
			queryParams: {
				limit: `${limit}`,
				offset: `${pageIndex * limit}`,
				...parseFilterValue(filterValue),
				...sorting,
			},
		})
	}
}

const parseFilterValue = (filterValue: InventoryListFilterValue) => {
	const result: any = {}
	for (const [key, value] of Object.entries(filterValue)) {
		if (Array.isArray(value) && value.length > 0) {
			result[key] = value
			continue
		}

		if (typeof value === "boolean") {
			if (value) {
				result[key] = value
			}
			continue
		}

		if (value !== "" && value !== undefined) {
			result[key] = value
		}
	}

	return result
}
